import React from "react";
import SummaryItem from './SummaryItem';
import {translate} from '../../i18n/translate.js';
import {URLs} from "../../common/constants";
import styles from "../../css/summary/summary.less";

class SummaryItems extends React.Component {
    onClickCallback = () => {
        if(this.props.isChangeAllowed()) {
            this.props.isFarmSeasonal ? this.props.onAddSubscriptionClick() : this.props.onChangeSubscriptionClick();
        }
    };
    onChangeFreeItemsClick = () => {
        if(this.props.isChangeAllowed()) {
            this.props.onChangeSubscriptionClick();
        }
    };

    render() {
        return (<div className="join-summary-items-wrapper" name="joinSummaryItems">
            <div className="summary-section-title">
                <div className="summary-title-label items-label">{translate(this.props.title)}</div>
                {this.props.isAllowModifySubscription ?
                    <button id="btnAddChangeSubscription" type="button" className="button btn btn-primary summary-change-button"
                         onClick={this.onClickCallback}>{translate(this.props.isFarmSeasonal ? "Add" : "Change")}</button>
                    : undefined
                }
                {this.props.isAllowModifySubscription && this.props.staticData.allowChangeFreeOptions ?
                    <button id="btnChangeFreeOptions" type="button" className="button btn btn-primary summary-change-button"
                         onClick={this.onChangeFreeItemsClick}><span className="hidden-xs">{translate("Select ")}</span>{translate("Free")}</button>
                    : undefined
                }
                {(this.props.flowType !== URLs.ACCOUNT || !this.props.staticData.hideDeliveryPrice) &&
                    <div className="summary-title-label total-label">{translate("Total")}</div>
                }
                <div className="summary-title-label qty-label">{translate("Qty")}.</div>
            </div>
            {this.props.items.map((item, index) => {
                const allowChange = !item.isAdditional && this.props.allowChangeShares ||
                    item.isAdditional && this.props.allowChangeOptions;
                return (
                    <SummaryItem key={index} item={item}
                                 readOnly={this.props.readOnly || !allowChange}
                                 staticData={this.props.staticData}
                                 isFarmSeasonal={this.props.isFarmSeasonal}
                                 schedules={this.props.schedules}
                                 pickupSite={this.props.pickupSite}
                                 showItemDetailsLink={this.props.showItemDetailsLink}
                                 includeTax={this.props.includeTax}
                                 onRemoveItem={this.props.onRemoveItem}
                                 flowType={this.props.flowType}
                    />
                );
            })}
        </div>);
    }
}

export default SummaryItems;



// WEBPACK FOOTER //
// ./src/components/summary/SummaryItems.js